import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Alert } from 'src/app/interfaces/alert';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthManagerService, PassUpdateWithToken } from 'src/app/services/auth-manager/auth-manager.service';
import * as UAParser from 'ua-parser-js';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})
export class SetNewPasswordComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  errorStrings = ErrorStrings;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  parser = new UAParser();
  isBrowser: boolean;

  model: PassUpdateWithToken = {
    password: '',
    token: ''
  };

  constructor(
    public authManager: AuthManagerService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  setPassword() {
    this.closeAlert();
    this.loading = true;
    this.authManager.setPasswordWithToken(this.model)
      .subscribe(
        () => {
          this.alert = {
            type: 'success',
            message: 'Your password has been updated.'
          };
          this.router.navigate(['/login']);
        },
        err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            if (err.error && err.error.error_code === 'invalid_data') {
              this.alert = {
                type: 'danger',
                message: 'The information entered are not valid or the reset password token is expired.'
              };
            } else {
              this.alert = {
                type: 'danger',
                message: 'An error has occurred. Please try again later.'
              };
            }
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  closeAlert() {
    this.alert = null;
  }

  ngOnInit(): void {
    const oSCheck = this.parser.getOS();
    this.model.token = this.route.snapshot.paramMap.get('token');
    if (oSCheck.name === "iOS") {
      const redirectTo = 'uk.co.identibase://reset-password';
      const parameterName = 'token';
      const parameterValue = this.model.token;
      if (this.isBrowser) {
        window.location.href = `${redirectTo}?${parameterName}=${parameterValue}`;
      }
    }
  }
}
